module.exports = __webpack_public_path__ + "img/logo.c1eb85f7.svg";